/* eslint-disable react/button-has-type */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
// import EmailIcon from "@mui/icons-material/Email";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import PhoneIcon from "@mui/icons-material/Phone";
// import SearchIcon from "@mui/icons-material/Search";
import { Box, TableCell, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import moment from "moment";
import * as Sentry from "@sentry/react";
import { Helmet } from "react-helmet";
import Pagination from "../../../components/common/new/Pagination/Pagination";
import { Constants } from "../../../contants";
import Reports from "../../../services/api/reports";
import Loader from "../../../components/common/Loader/Loader";

import // FRIEND_SEAECH_TABLE_COL,
// FRIEND_SEARCH_COL,
"../../../contants/table/friendSearch";
// import { SET_SELECTED_FRIEND } from "../../../redux/actionTypes/dashboard";
import ReloadIcon from "../../../assets/svg/ReloadIcon";
import Button from "../../../components/common/Button";
// import tableStyle from "../../../theme/styles/table";
import style from "./DownloadReportstyles";
import { performOperation } from "../../member/MemberSearch/utils";
import Table from "../../../components/common/new/Table/Table";
import useUserConfig from "../../../hooks/useUserConfig";
import Toast from "../../../components/common/Toast";
import styles from "../Components/ReportsTable/ReportsTable.styles";
import Typography from "../../../components/common/new/Typography/Typography";
// import NewTable from "../../member/components/Newtable/NewTable";

const DOWNLOAD_REPORTS_TABLE_COL = [
  {
    displayName: "S.No",
  },
  {
    displayName: "Report Name",
  },
  // {
  //   displayName: "Search Filters",
  // },
  {
    displayName: "Generated At",
  },
  {
    displayName: "Status",
  },
  {
    displayName: "Action",
  },
];

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const openExcelInNewTab = async (downloadInfoId) => {
  try {
    const match = downloadInfoId.match(/-(\d+)$/);
    if (match) {
      const extractedNumber = match[1];
      const response = await Reports.getDownlaodReportLink(extractedNumber);
      if (response.code === 200) {
        window.open(response.data.signedS3Url, "_blank");
      } else {
        console.error("API Error:", response);
      }
    }
  } catch (error) {
    Sentry.captureException(error);
  }
};

const getRows = (data, currentPage, downloadSize) =>
  data.map((downloadInfo, index) => {
    const serialNumber = index + 1 + currentPage * downloadSize;
    return (
      <TableRow key={serialNumber}>
        <TableCell>{serialNumber}</TableCell>
        <TableCell>{downloadInfo.name || "-"}</TableCell>
        {/* <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {downloadInfo.extraInfo.reportParams || "-"}
            </Typography>
          </div>
        </TableCell> */}
        <TableCell style={tabelCellWidth.small}>
          <div style={styles.tableBox}>
            <Typography style={styles.typoghrphyStyle}>
              {moment(downloadInfo.updatedAt).format("DD/MM/YYYY, h:mm:ss a") ||
                "-"}
            </Typography>
          </div>
        </TableCell>
        <TableCell>{downloadInfo.status || "-"}</TableCell>
        <TableCell>
          {downloadInfo.status === "COMPLETED" &&
          downloadInfo.result &&
          downloadInfo.result.s3Url ? (
            <Button
              onClick={() => openExcelInNewTab(downloadInfo.name)}
              label="Download"
            />
          ) : (
            <Button
              label="Download"
              disabled
              style={{
                backgroundColor: "grey",
                "&:hover": {
                  backgroundColor: "grey",
                },
              }}
            />
          )}
        </TableCell>
      </TableRow>
    );
  });
const LOADER_DELAY = 1000;
const DEFAULT_PAGE_SIZE = 5;

function DownloadReports() {
  const TITLE = "Download Report - BSG";
  const [reportsdata, setDownloadReportsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalDownloadPages, setTotalPages] = useState(0);
  const [totalDownloadElements, setTotalElements] = useState(0);
  const [downloadSize, setSize] = useState(Constants.DEFAULT_PAGE_SIZE);
  const hasPermission = useUserConfig();
  const [showToast, setShowToast] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const laoding = useSelector((store) => store.view_friends.isLoading);

  async function fetchData(pageNumber, pageSize) {
    try {
      setIsLoading(true);
      const response = await Reports.downloadReports({
        pageNumber,
        pageSize,
      });

      if (response.code === 200) {
        const { content, totalPages, totalElements, size } = response.data;
        setCurrentPage(pageNumber);
        setSize(size);
        setTimeout(() => {
          setTotalPages(totalPages);
          setTotalElements(totalElements);
          setDownloadReportsData(content);
          setIsLoading(false);
        }, LOADER_DELAY);
      } else {
        console.error("API Error:", response);
      }
    } catch (error) {
      setIsLoading(false);
      Sentry.captureException(error);
    }
  }

  const onSearchClick = (pageNumber, pageSize) => {
    fetchData(pageNumber, pageSize);
  };

  const onPaginationClick = (page) => {
    onSearchClick(page, downloadSize);
  };
  const onRefresh = () => {
    fetchData(0, DEFAULT_PAGE_SIZE);
  };

  const onPageSizeClick = (operator) => {
    // const { pageSize } = paginationInfo;
    const newPageSize = performOperation(
      downloadSize,
      Constants.DEFAULT_PAGE_SIZE,
      operator
    );
    onSearchClick(0, newPageSize);
  };

  useEffect(() => {
    fetchData(currentPage, downloadSize);
  }, [currentPage, downloadSize]);

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box sx={style.container}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: "1rem",
          }}
        >
          <Box style={styles.reload} onClick={onRefresh}>
            <ReloadIcon />
          </Box>
        </Box>
        {reportsdata?.length ? (
          <Box style={style.tableContainer}>
            <Box style={style.tableHeading}>
              <Box style={style.tableTitle}>Download Reports</Box>
              <Box style={style.tableInfo}>
                Total Reports: {totalDownloadElements}
              </Box>
            </Box>
            <Table
              scrollable
              columns={DOWNLOAD_REPORTS_TABLE_COL}
              rows={getRows(
                reportsdata,
                currentPage,
                downloadSize,
                hasPermission
              )}
              // hasAction
              hasPermission
              tableBodyTheme="#F6F6F6"
              tableHeadCellStyle={{
                ...style.tableHeadCells,
                textAlign: "center",
              }}
            />
            <Box style={style.pagination}>
              <Pagination
                totalPages={totalDownloadPages}
                totalResults={totalDownloadElements}
                currentPage={currentPage}
                pageSize={downloadSize}
                onChange={onPaginationClick}
                onPageSizeClick={onPageSizeClick}
              />
            </Box>
          </Box>
        ) : (
          !reportsdata?.length &&
          laoding === false && (
            <Box style={style.emptyContainer}>
              <h1 style={style.noDataMsg}>No Results</h1>
            </Box>
          )
        )}
        {isLoading && <Loader />}

        <Toast
          open={!!showToast}
          severity={showToast?.severity || ""}
          message={showToast?.message || ""}
          handleClose={() => {
            setShowToast(null);
          }}
        />
      </Box>
    </>
  );
}

export default DownloadReports;
